import { gql } from '../GraphQLClient';
import { defaultsTo } from '../../utils/utilsGlobal';

export const fragmentTask = gql`
  fragment fragmentTask on Task {
    id
    url
    title
    provider
    providerId
    issuesCount
  }
`;

export function serializeTask(data){
  return defaultsTo(data, {
    id: null,
    url: '',
    title: '',
    providerId: '',
    provider: null,
    issuesCount: 0,
  });
}
